export default __webpack_public_path__ + "static/media/chat-bots-screen-1.224f1744.jpg";